import React from 'react';
import Modal from './Modal';

const ShowUsers = ({ loggedAttendants = [], altIcon }) => {
  return <Modal users={loggedAttendants} altIcon={altIcon} />;
};

export default ShowUsers;
